const env = process.env;

const valid = (value, pattern) => {
  const v = (value || "").trim();
  return v && pattern.test(v) && !/X{4,}/.test(v) ? v : "";
};

// Central tracking config. Only PUBLIC identifiers live here; the CAPI access token stays on the server.
export const trackingConfig = {
  GTM_ID: valid(env.NEXT_PUBLIC_GTM_ID, /^GTM-[A-Z0-9]+$/),
  META_PIXEL_ID: valid(env.NEXT_PUBLIC_META_PIXEL_ID, /^\d{10,20}$/),
  GA4_ID: valid(env.NEXT_PUBLIC_GA4_ID, /^G-[A-Z0-9]+$/),
  META_CAPI_ENABLED: env.NEXT_PUBLIC_META_CAPI_ENABLED !== "false",
  META_CAPI_API_VERSION: env.NEXT_PUBLIC_META_API_VERSION || "v21.0",
  WHATSAPP_NUMBER: (env.NEXT_PUBLIC_WHATSAPP_NUMBER || "").replace(/\D/g, ""),
  PHONE_NUMBER: env.NEXT_PUBLIC_PHONE_NUMBER || "",
  AD_PHONE_NUMBER: env.NEXT_PUBLIC_AD_PHONE_NUMBER || "",
  CURRENCY: env.NEXT_PUBLIC_CURRENCY || "INR",
  DEBUG: env.NEXT_PUBLIC_TRACKING_DEBUG === "true",
  TRACKING_TEST_ENABLED: env.NEXT_PUBLIC_ENABLE_TRACKING_TEST === "true",
  BACKEND_URL: env.REACT_APP_BACKEND_URL || "",
};

export const dlog = (channel, ...args) => {
  if (!trackingConfig.DEBUG) return;
  // eslint-disable-next-line no-console
  console.log(`%c[track:${channel}]`, "color:#0D3B2E;font-weight:700", ...args);
};
